<template>
  <div class="tw-w-full tw-h-auto">
    <div
      :class="`tw-px-[20px] tw-py-[40px] sm:tw-p-[40px] tw-flex tw-flex-col tw-gap-[25px]`"
    >
      <div
        v-if="dataSuggestedActionTable.length > 0"
        :class="`tw-flex tw-flex-col tw-justify-between tw-w-full tw-min-h-[51px] tw-gap-2.5`"
      >
        <div class="tw-flex tw-items-center tw-gap-2.5 tw-h-[21px]">
          <span
            class="tw-text-[#211F58] tw-text-[16px] tw-font-[600] tw-not-italic tw-leading-[21px]"
            >{{
              getComponentUiText(
                "app-assess-recommendations-create-action-suggested-tab-title-1",
              )
            }}</span
          >
        </div>
        <span
          class="tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-leading-normal"
        >
          {{
            getComponentUiText(
              "app-assess-recommendations-create-action-suggested-tab-description-1",
            ).split("{##titleButton##}")[0]
          }}
          <span class="tw-font-bold">{{
            getComponentUiText(
              "app-assess-recommendations-create-action-button-title-use-1",
            )
          }}</span>
          {{
            getComponentUiText(
              "app-assess-recommendations-create-action-suggested-tab-description-1",
            ).split("{##titleButton##}")[1]
          }}
        </span>
      </div>
      <SuggestionActionsTable
        v-if="dataSuggestedActionTable.length > 0"
        class="tw-mb-[40px]"
        :data-row="dataSuggestedActionTable"
        :header-class="'tw-h-[56px] tw-items-center tw-ml-[7px]'"
        :row-class="'tw-ml-[7px]'"
        :title-button="
          getComponentUiText(
            'app-assess-recommendations-create-action-button-title-use-1',
          )
        "
        :title-action-value="
          getComponentUiText(
            'app-assess-recommendations-make-plan-table-action-1',
          )
        "
        :is-show-checkbox="false"
        :is-show-meatball="false"
        :is-show-loading="true"
        @update-add-action="handleUseAction($event)"
      />
      <div
        v-else
        class="tw-text-center tw-font-[400] tw-leading-[145%] tw-text-[15px] tw-text-[#878787]"
      >
        {{
          getComponentUiText(
            "app-assess-recommendations-section-action-empty-suggest-action-table-title-1",
          )
        }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import SuggestionActionsTable from "@/components/recommend/suggestedActionsTable.vue";

import { dataActionTableColumn } from "./actionsTable.vue";
import { computed } from "vue";
import { Ref } from "vue";
import store from "@/store";
import { getComponentUiText } from "@/utils/utilities";

const dataSuggestedActionTable: Ref<dataActionTableColumn[]> = computed(() => {
  const recommendState = store.state.Recommend;
  if (!recommendState) {
    return [];
  }
  const checklistGroupMetrics =
    recommendState.recommendChecklistGroupMetrics || [];
  const checklistGroupTemplateMetrics =
    recommendState.ChecklistGroupTemplateMetrics || [];

  const dataFilterByGroupId = checklistGroupMetrics.flatMap((item) => {
    return item.checklistGroupTemplateIds || [];
  });

  const filteredChecklistGroupTemplateMetrics =
    checklistGroupTemplateMetrics.filter((item) => {
      return !dataFilterByGroupId.includes(item.id);
    });

  return filteredChecklistGroupTemplateMetrics;
});

const emit = defineEmits(["update:use"]);

const handleUseAction = (data: dataActionTableColumn) => {
  emit("update:use", data);
};
</script>

<style lang="scss" scoped>
.hiddenBorderFirstChild > div:first-of-type {
  border: none !important;
}

.edit-modal-action {
  max-height: calc(100vh - 150px) !important;
  top: 103px !important; // 115px + 56px
}
</style>
